module.exports = __webpack_public_path__ + "static/media/blog-36-img3.1b74d67e.webp";